import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from 'app/App';
import { store } from 'app/store/store';
import * as serviceWorkerRegistration from 'app/config/pwa/serviceWorkerRegistration';
import ErrorBoundary from "app/error/ErrorBoundary";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
      <Provider store={store}>
       <ErrorBoundary>
           <App/>
       </ErrorBoundary>
      </Provider>

);


serviceWorkerRegistration.unregister();

